<template>
  <div>
    <div
      v-if="carregando"
      class="text-center py-5"
    >
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!retencao"
      class="text-center text-muted py-5"
    >
      {{ $t('retention.detail.notFound') }}
    </div>

    <div
      v-else
      class="row"
    >
      <div class="col-lg-7 mb-1">
        <b-card no-body>
          <div class="det__topo">
            <div>
              <div class="det__nome">
                {{ retencao.equipment ? retencao.equipment.name : '—' }}
              </div>
              <div
                v-if="detalheEquipamento"
                class="det__sub"
              >
                {{ detalheEquipamento }}
              </div>
            </div>
            <span :class="['selo', seloDaSituacao]">
              {{ rotuloSituacao }}
            </span>
          </div>

          <div class="det__numeros">
            <div class="det__num">
              <div class="det__num-valor">
                {{ retencao.quantity }}
              </div>
              <div class="det__num-rotulo">
                {{ $t('retention.detail.retainedQty') }}
              </div>
            </div>
            <div class="det__num">
              <div class="det__num-valor">
                {{ retencao.returned_quantity }}
              </div>
              <div class="det__num-rotulo">
                {{ $t('retention.detail.returnedQty') }}
              </div>
            </div>
            <div class="det__num">
              <div
                class="det__num-valor"
                :class="{ 'det__num-valor--alerta': retencao.pending_quantity > 0 }"
              >
                {{ retencao.pending_quantity }}
              </div>
              <div class="det__num-rotulo">
                {{ $t('retention.common.pending') }}
              </div>
            </div>
          </div>

          <div class="det__campos">
            <div
              v-for="campo in campos"
              :key="campo.rotulo"
              class="det__campo"
            >
              <div class="det__campo-rotulo">
                {{ campo.rotulo }}
              </div>
              <div class="det__campo-valor">
                {{ campo.valor }}
              </div>
            </div>
          </div>

          <div
            v-if="!retencao.returned_at"
            class="det__acoes"
          >
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click="abrirBaixa"
            >
              <feather-icon
                icon="CornerUpLeftIcon"
                size="14"
                class="mr-25"
              />
              {{ $t('retention.detail.checkInButton') }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              @click="abrirEdicao"
            >
              <feather-icon
                icon="Edit2Icon"
                size="14"
                class="mr-25"
              />
              {{ $t('common.edit') }}
            </button>
          </div>

          <div
            v-if="retencao.has_signature"
            class="det__assinaturas"
          >
            <SignatureViewer
              v-if="retencao.has_signature"
              :url="urlAssinatura('signature')"
              :rotulo="$t('retention.detail.signatureLabel')"
              :titulo="$t('retention.detail.signatureLabel')"
            />
          </div>
        </b-card>
      </div>

      <div class="col-lg-5">
        <b-card no-body>
          <div class="det__tl-titulo">
            <feather-icon
              icon="ClockIcon"
              size="15"
              class="mr-50 text-primary"
            />
            {{ $t('retention.detail.timelineTitle') }}
          </div>

          <div class="det__tl">
            <div
              v-for="(ev, idx) in eventos"
              :key="idx"
              class="tl__item"
            >
              <div class="tl__trilho">
                <div
                  class="tl__ponto"
                  :style="{ backgroundColor: corDoEvento(ev.kind) }"
                />
                <div
                  v-if="idx < eventos.length - 1"
                  class="tl__conector"
                  :style="{ borderLeftColor: corDoEvento(ev.kind) + '40' }"
                />
              </div>

              <div class="tl__corpo">
                <div class="tl__linha">
                  <span
                    class="tl__rotulo"
                    :style="{ color: corDoEvento(ev.kind) }"
                  >
                    {{ ev.label }}
                    <template v-if="ev.quantity"> &middot; {{ ev.quantity }}</template>
                  </span>
                  <span class="tl__data">{{ dataHora(ev.at) }}</span>
                </div>
                <div
                  v-if="ev.location"
                  class="tl__meta"
                >
                  <feather-icon
                    icon="MapPinIcon"
                    size="11"
                    class="mr-25"
                  />{{ ev.location }}
                </div>
                <div
                  v-if="ev.responsible"
                  class="tl__meta"
                >
                  <feather-icon
                    icon="UserCheckIcon"
                    size="11"
                    class="mr-25"
                  />{{ ev.responsible }}
                </div>
                <div
                  v-if="ev.user"
                  class="tl__meta"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="11"
                    class="mr-25"
                  />{{ ev.user }}
                </div>
                <div
                  v-if="ev.notes"
                  class="tl__obs"
                >
                  "{{ ev.notes }}"
                </div>
                <SignatureViewer
                  v-if="ev.has_signature && ev.return_id"
                  :url="urlAssinaturaBaixa(ev.return_id)"
                  :rotulo="$t('retention.detail.signatureShort')"
                  :titulo="$t('retention.detail.checkInSignatureTitle')"
                />
              </div>
            </div>
          </div>

          <div
            v-if="!retencao.returned_at"
            class="det__lancar"
          >
            <div class="det__lancar-campos">
              <select
                v-model="lancamento.situation"
                class="form-control form-control-sm"
              >
                <option :value="null">
                  {{ $t('retention.detail.registerSituationPlaceholder') }}
                </option>
                <option
                  v-for="sit in situacoes"
                  :key="sit.value"
                  :value="sit.value"
                >
                  {{ sit.label }}
                </option>
              </select>
            </div>
            <textarea
              v-model="lancamento.notes"
              class="form-control form-control-sm mt-50"
              rows="2"
              maxlength="500"
              :placeholder="$t('retention.detail.notesOptionalPlaceholder')"
            />
            <div class="text-right mt-50">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                :disabled="salvando || !lancamento.situation"
                @click="registrarSituacao"
              >
                {{ salvando ? $t('retention.common.saving') : $t('retention.detail.addToTimeline') }}
              </button>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal
      v-model="modalBaixa"
      :title="$t('retention.detail.checkInButton')"
      size="md"
      centered
      lazy
      hide-footer
    >
      <template v-if="retencao">
        <p class="mb-1">
          <strong>{{ retencao.equipment ? retencao.equipment.name : '—' }}</strong>
          &mdash; {{ retencao.pending_quantity }} {{ $t('retention.common.pendingOf', { total: retencao.quantity }) }}
        </p>

        <div class="form-row">
          <div class="form-group col-4">
            <label>{{ $t('retention.common.quantityReturned') }}</label>
            <input
              v-model.number="baixa.quantity"
              type="number"
              class="form-control"
              min="1"
              :max="retencao.pending_quantity"
            >
          </div>
          <div class="form-group col-8">
            <label>{{ $t('retention.common.returnedBy') }}</label>
            <input
              v-model="baixa.responsible_name"
              type="text"
              class="form-control"
              maxlength="180"
              :placeholder="$t('retention.common.optional')"
            >
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t('retention.common.notes') }}</label>
          <textarea
            v-model="baixa.notes"
            class="form-control"
            rows="2"
            maxlength="255"
            :placeholder="$t('retention.common.optional')"
          />
        </div>

        <div
          v-if="baixaParcial"
          class="aviso-parcial"
        >
          {{ $t('retention.common.partialWarning', { count: retencao.pending_quantity - baixa.quantity }) }}
        </div>

        <div
          class="d-flex justify-content-end mt-1"
          style="gap: 8px"
        >
          <button
            type="button"
            class="btn btn-outline-secondary"
            :disabled="salvando"
            @click="modalBaixa = false"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            :disabled="salvando || !baixaValida"
            @click="confirmarBaixa"
          >
            {{ salvando ? $t('retention.common.saving') : $t('retention.common.confirm') }}
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="modalEdicao"
      :title="$t('retention.detail.editModalTitle')"
      size="md"
      centered
      lazy
      hide-footer
    >
      <div class="form-group">
        <label>{{ $t('retention.detail.unitLabel') }}</label>
        <select
          v-if="unidades.length"
          v-model="edicao.establishment_id"
          class="form-control"
        >
          <option :value="null">
            {{ $t('retention.detail.notRegisteredOption') }}
          </option>
          <option
            v-for="u in unidades"
            :key="u.id"
            :value="u.id"
          >
            {{ u.establishment_name }}
          </option>
        </select>
        <input
          v-else
          v-model="edicao.location"
          type="text"
          class="form-control"
          maxlength="180"
          :placeholder="$t('retention.detail.locationPlaceholder')"
        >
      </div>

      <div
        v-if="unidades.length && !edicao.establishment_id"
        class="form-group"
      >
        <label>{{ $t('retention.detail.describeUnitLabel') }}</label>
        <input
          v-model="edicao.location"
          type="text"
          class="form-control"
          maxlength="180"
        >
      </div>

      <div class="form-group">
        <label>{{ $t('retention.detail.responsibleProfessionalLabel') }}</label>
        <input
          v-model="edicao.responsible_name"
          type="text"
          class="form-control"
          maxlength="180"
        >
      </div>

      <div class="form-group">
        <label>{{ $t('retention.common.notes') }}</label>
        <textarea
          v-model="edicao.notes"
          class="form-control"
          rows="2"
          maxlength="255"
        />
      </div>

      <div
        class="d-flex justify-content-end"
        style="gap: 8px"
      >
        <button
          type="button"
          class="btn btn-outline-secondary"
          :disabled="salvando"
          @click="modalEdicao = false"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="salvando"
          @click="salvarEdicao"
        >
          {{ salvando ? $t('retention.common.saving') : $t('common.save') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import ApiErrorMixin from '@/mixins/ApiErrorMixin'
import EquipmentRetentionEventsMixin from '@/mixins/EquipmentRetentionEventsMixin'
import SignatureViewer from '@/components/SignatureViewer.vue'

const CORES = {
  retained: '#ff9f43',
  returned: '#00cfe8',
  closed: '#28c76f',
  contato: '#7367f0',
  sem_resposta: '#ea5455',
  prazo: '#7367f0',
  extraviado: '#ea5455',
  nota: '#8592a3',
}

const SELOS = {
  extraviado: 'selo--perigo',
  sem_resposta: 'selo--perigo',
  recuperado: 'selo--ok',
}

export default {
  name: 'RetentionDetail',
  components: { BSpinner, SignatureViewer },
  mixins: [ApiErrorMixin, EquipmentRetentionEventsMixin],

  data() {
    return {
      retencao: null,
      eventos: [],
      baixas: [],
      situacoes: [],
      lancamento: { situation: null, notes: '' },
      unidades: [],
      modalBaixa: false,
      modalEdicao: false,
      baixa: { quantity: 1, responsible_name: '', notes: '' },
      edicao: {
        establishment_id: null, location: '', responsible_name: '', notes: '',
      },
      carregando: false,
      salvando: false,
    }
  },

  computed: {
    baixaValida() {
      if (!this.retencao) return false
      const q = Number(this.baixa.quantity)

      return q >= 1 && q <= this.retencao.pending_quantity
    },

    baixaParcial() {
      return this.baixaValida && Number(this.baixa.quantity) < this.retencao.pending_quantity
    },

    rotuloSituacao() {
      const r = this.retencao
      if (!r) return ''
      if (r.returned_at) return this.$t('retention.common.recovered')

      const achado = this.situacoes.find(s => s.value === r.situation)

      return achado ? achado.label : this.$t('retention.common.pending')
    },

    seloDaSituacao() {
      const r = this.retencao
      if (!r) return 'selo--pendente'
      if (r.returned_at) return 'selo--ok'

      return SELOS[r.situation] || 'selo--pendente'
    },

    textoDevolvidoA() {
      const comNome = this.baixas.filter(b => b.responsible_name)

      if (!comNome.length) return '—'
      if (comNome.length === 1) return comNome[0].responsible_name

      return this.$t('retention.detail.multiplePeopleTimeline', { count: comNome.length })
    },

    detalheEquipamento() {
      const e = this.retencao && this.retencao.equipment
      if (!e) return ''

      const unidade = (e.unit && e.unit.abbreviation)
        || (e.type && e.type.unit && e.type.unit.abbreviation)
        || ''
      const partes = []

      if (e.measure_value) partes.push(`${e.measure_value} ${unidade}`.trim())
      if (e.serial) partes.push(e.serial)
      if (e.type && e.type.name) partes.push(e.type.name)

      return partes.join(' · ')
    },

    campos() {
      const r = this.retencao
      if (!r) return []

      return [
        { rotulo: this.$t('retention.fields.occurrence'), valor: r.occurrence ? r.occurrence.protocol : '—' },
        { rotulo: this.$t('retention.fields.team'), valor: r.team ? r.team.name : '—' },
        {
          rotulo: this.$t('retention.fields.whereKept'),
          valor: (r.establishment && r.establishment.establishment_name)
            || r.location || this.$t('retention.common.notInformed'),
        },
        { rotulo: this.$t('retention.fields.receivedBy'), valor: r.responsible_name || '—' },
        { rotulo: this.$t('retention.detail.returnedToLabel'), valor: this.textoDevolvidoA },
        { rotulo: this.$t('retention.common.notes'), valor: r.notes || '—' },
      ]
    },
  },

  mounted() {
    this.carregar()
    this.carregarSituacoes()
    this.carregarUnidades()
    this.watchRetentionEvents()
  },

  methods: {
    async carregar() {
      this.carregando = this.retencao === null
      try {
        const res = await this.$http.get(
          `${this.$store.state.api}equipment/retentions/${this.$route.params.id}`,
        )
        const dados = res.data.data || {}
        this.retencao = dados.retention || null
        this.baixas = dados.returns || []
        this.eventos = dados.events || []
      } catch (e) {
        this.retencao = null
        this.baixas = []
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.detail.loadError')), 'error')
      } finally {
        this.carregando = false
      }
    },

    async carregarUnidades() {
      try {
        const res = await this.$http.get(`${this.$store.state.api}establishments`, {
          params: { paginated: false, status: 1 },
        })
        this.unidades = res.data.data || []
      } catch (e) {
        this.unidades = []
      }
    },

    abrirBaixa() {
      this.baixa = {
        quantity: this.retencao.pending_quantity, responsible_name: '', notes: '',
      }
      this.modalBaixa = true
    },

    async confirmarBaixa() {
      if (!this.baixaValida) return

      this.salvando = true
      try {
        await this.$http.post(
          `${this.$store.state.api}equipment/retentions/${this.retencao.id}/return`,
          {
            quantity: Number(this.baixa.quantity),
            responsible_name: this.baixa.responsible_name || null,
            notes: this.baixa.notes || null,
          },
        )
        this.$message(this.$t('retention.common.successTitle'), this.$t('retention.common.recoverySuccess'), 'success')
        this.modalBaixa = false
        await this.carregar()
      } catch (e) {
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.detail.checkInError')), 'error')
      } finally {
        this.salvando = false
      }
    },

    abrirEdicao() {
      this.edicao = {
        establishment_id: this.retencao.establishment_id || null,
        location: this.retencao.location || '',
        responsible_name: this.retencao.responsible_name || '',
        notes: this.retencao.notes || '',
      }
      this.modalEdicao = true
    },

    async salvarEdicao() {
      this.salvando = true
      try {
        await this.$http.put(`${this.$store.state.api}equipment/retentions/${this.retencao.id}`, {
          establishment_id: this.edicao.establishment_id || null,
          location: this.edicao.location || null,
          responsible_name: this.edicao.responsible_name || null,
          notes: this.edicao.notes || null,
        })
        this.$message(this.$t('retention.common.successTitle'), this.$t('retention.detail.updateSuccess'), 'success')
        this.modalEdicao = false
        await this.carregar()
      } catch (e) {
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.detail.saveError')), 'error')
      } finally {
        this.salvando = false
      }
    },

    async carregarSituacoes() {
      try {
        const res = await this.$http.get(`${this.$store.state.api}equipment/retentions/situations`)
        this.situacoes = res.data.data || []
      } catch (e) {
        this.situacoes = []
      }
    },

    async registrarSituacao() {
      if (!this.lancamento.situation) return

      this.salvando = true
      try {
        await this.$http.post(
          `${this.$store.state.api}equipment/retentions/${this.$route.params.id}/updates`,
          { situation: this.lancamento.situation, notes: this.lancamento.notes || null },
        )
        this.lancamento = { situation: null, notes: '' }
        await this.carregar()
      } catch (e) {
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.detail.registerError')), 'error')
      } finally {
        this.salvando = false
      }
    },

    onRetentionEvent(payload) {
      if (Number(payload.retention_id) !== Number(this.$route.params.id)) return
      this.carregar()
    },

    corDoEvento(kind) {
      return CORES[kind] || '#8592a3'
    },

    urlAssinaturaBaixa(returnId) {
      return `${this.$store.state.api}equipment/retention-returns/${returnId}/signature`
    },

    urlAssinatura(tipo) {
      return `${this.$store.state.api}equipment/retentions/${this.retencao.id}/${tipo}`
    },

    dataHora(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR')
    },
  },
}
</script>

<style scoped>
.det__topo {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid #ebe9f1;
}

.det__nome {
  font-size: 17px;
  font-weight: 600;
  color: #5e5873;
  line-height: 1.25;
}

.det__sub {
  font-size: 12.5px;
  color: #8592a3;
  margin-top: 2px;
}

.det__numeros {
  display: flex;
  border-bottom: 1px solid #ebe9f1;
}

.det__num {
  flex: 1 1 0;
  padding: 14px 18px;
  border-right: 1px solid #f3f2f7;
}

.det__num:last-child {
  border-right: none;
}

.det__num-valor {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  color: #5e5873;
}

.det__num-valor--alerta {
  color: #ff9f43;
}

.det__num-rotulo {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #b9b9c3;
  margin-top: 2px;
}

.det__campos {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 18px;
  padding: 16px 18px;
}

.det__campo-rotulo {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #b9b9c3;
}

.det__campo-valor {
  font-size: 13.5px;
  color: #6e6b7b;
  overflow-wrap: anywhere;
}

.det__acoes {
  display: flex;
  gap: 8px;
  padding: 0 18px 16px;
}

.aviso-parcial {
  padding: 8px 12px;
  border-radius: 6px;
  background: #fdf3e4;
  color: #b45309;
  font-size: 12.5px;
}

.dark-layout .aviso-parcial {
  background: #2e2214;
  color: #e5a95c;
}

.det__assinaturas {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  padding: 0 18px 16px;
}

.det__tl-titulo {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #ebe9f1;
  font-weight: 600;
  font-size: 14px;
  color: #5e5873;
}

.det__tl {
  padding: 16px 18px;
}

.tl__item {
  display: flex;
  gap: 12px;
}

.tl__trilho {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 10px;
}

.tl__ponto {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 5px;
  flex: none;
}

.tl__conector {
  flex: 1 1 auto;
  border-left: 2px solid;
  margin: 3px 0;
}

.tl__corpo {
  flex: 1 1 auto;
  min-width: 0;
  padding-bottom: 16px;
}

.tl__linha {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.tl__rotulo {
  font-weight: 600;
  font-size: 13.5px;
}

.tl__data {
  font-size: 11px;
  color: #b9b9c3;
  white-space: nowrap;
}

.tl__meta {
  font-size: 11.5px;
  color: #8592a3;
  margin-top: 2px;
}

.tl__obs {
  font-size: 11.5px;
  font-style: italic;
  color: #6e6b7b;
  margin-top: 4px;
}

/* dark mode */
.dark-layout .det__topo,
.dark-layout .det__numeros,
.dark-layout .det__tl-titulo {
  border-bottom-color: #3b4253;
}

.dark-layout .det__num {
  border-right-color: #3b4253;
}

.dark-layout .det__nome,
.dark-layout .det__num-valor,
.dark-layout .det__tl-titulo {
  color: #d0d2d6;
}

.dark-layout .det__campo-valor,
.dark-layout .tl__obs {
  color: #b4b7bd;
}

.dark-layout .det__num-rotulo,
.dark-layout .det__campo-rotulo {
  color: #676d7d;
}

.selo {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 4px;
  white-space: nowrap;
}

.selo--pendente {
  color: #ff9f43;
  background: rgba(255, 159, 67, 0.14);
}

.selo--perigo {
  color: #ea5455;
  background: rgba(234, 84, 85, 0.14);
}

.det__lancar {
  padding: 0 18px 16px;
}

.det__lancar-campos {
  display: flex;
  gap: 8px;
}

.selo--ok {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
}
</style>
